import { Component, Input, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { OrganizationsService } from 'src/app/modules/organization/services/organizations.service'
import { environment } from 'src/environments/environment'
import { PayoutStatus } from '../../models/client-payout.enum'
import { ClientPayoutList } from '../../models/client-payout'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { PayoutService } from '../../services/payout.service'

@Component({
	selector: 'app-client-payout-list',
	templateUrl: './client-payout-list.component.html',
	styleUrls: ['./client-payout-list.component.scss'],
})
export class ClientPayoutListComponent implements OnInit {
	subscription = new Subscription()
	activeCountries!: any
	noDataFoundMessage = 'PAYOUT.PAYOUT_CLIENT.NO_SERVICEPROVIDERS_FOUND'

	payoutFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		fromDate: '',
		toDate: '',
		activeTab: 1,
		countryId: null,
	}
	filterCount = 0
	payouts: ClientPayoutList[] = []
	payoutStatus = PayoutStatus
	totalCount = 0
	attachementUrl = environment.attachmentPath

	constructor(
		private organizationServ: OrganizationsService,
		public translate: TranslateService,
		private ActivatedRoute: ActivatedRoute,
		private payoutService: PayoutService,
		private router: Router,
		private SharedService: SharedService
	) {
		this.SharedService.headerTitle.next(`PAYOUT.PAYOUT_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		this.getActiveCountries()
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.payoutFilter.countryId = res['country'] || 224
				this.payoutFilter.activeTab = res['activeTab'] || 1
				this.payoutFilter.paging.pageNumber = res['page'] || 1
				this.payoutFilter.paging.pageSize = res['count'] || 10
				this.SharedService.handleBreadCrumb('payouts', true, {
					name: '',
					id: '',
					url: '/layout/payouts/clients-payout',
					queryParams: { ...res },
				})
				this.getPayouts()
				this.getPendingCount()
			})
		)
	}
	getPayouts(search = false, filter: any = null) {
		search
			? (this.payoutFilter.paging.pageNumber = 1)
			: this.payoutFilter.paging.pageNumber

		filter
			? (this.payoutFilter = { ...this.payoutFilter, ...filter })
			: this.payoutFilter
		this.subscription.add(
			this.payoutService
				.getClientPayoutList(this.payoutFilter)
				.subscribe((res: any) => {
					this.payouts = res.result.items
					this.totalCount = res.result.totalCount
				})
		)
	}
	getPendingCount(search = false, filter: any = null) {
		search ? (this.payoutFilter.paging.pageNumber = 1) : null

		filter ? (this.payoutFilter = { ...this.payoutFilter, ...filter }) : null
		const body = {
			searchText: this.payoutFilter.searchText,
			activeTab: 1,
			countryId: this.payoutFilter.countryId,
		}
		this.subscription.add(
			this.payoutService.getClientPendingCount(body).subscribe((res: any) => {
				let pending = this.payoutStatus.find((val) => val.value == '1')

				pending
					? ((pending.count = res.result.pendingCount),
					  (pending.showCount = res.result.pendingCount ? true : false))
					: null
			})
		)
	}
	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}
	tapChanged(event: any) {
		this.router.navigate(['/layout/payouts/clients-payout'], {
			queryParams: {
				country: this.payoutFilter.countryId,
				activeTab: event,
			},
		})
	}

	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/payouts/clients-payout'], {
			queryParams: {
				country: this.payoutFilter.countryId,
				activeTab: this.payoutFilter.activeTab,
				page: pageNumber,
				count: pagecount,
			},
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
